export default __webpack_public_path__ + "static/media/avatar_136.6237e367.png";